/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Align_Right_Left_Justify_Right_PosInputs */



/**
* | output |
* | --- |
* | "Left Justify / Right Position" |
*
* @param {Align_Right_Left_Justify_Right_PosInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const align_right_left_justify_right_pos = /** @type {((inputs?: Align_Right_Left_Justify_Right_PosInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Align_Right_Left_Justify_Right_PosInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Justification Gauche / Position Droite")
	if (locale === "de") return /** @type {LocalizedString} */ ("Linksbündig / Rechtsposition")
	if (locale === "it") return /** @type {LocalizedString} */ ("Giustifica a sinistra / Posizione a destra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выравнивание по левому краю / Позиционирование по правому краю")
	if (locale === "es") return /** @type {LocalizedString} */ ("Justificar a la izquierda / Posición a la derecha")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("左对齐/右对齐")
	if (locale === "ja") return /** @type {LocalizedString} */ ("左揃え / 右揃え")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बाएँ संरेखित करें / दाएँ स्थिति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Justificar à esquerda / Posicionamento à direita")
	return /** @type {LocalizedString} */ ("Left Justify / Right Position")
});